import { HYDRATE } from 'next-redux-wrapper';
import { RootState } from '../store';
import { TranslatorTFunction } from '../shared/i18n/getTranslator';

export const INITIALISE = 'listingsSort/INITIALISE';
export const UPDATE_CURRENT_SORT_ORDER =
    'listingsSort/UPDATE_CURRENT_SORT_ORDER';
export const RESET_SORT_ORDER = 'listingsSort/RESET_SORT_ORDER';

export type SortOrderOption = {
    label: string;
    value: string;
};

export type RawSortOrderOption = {
    i18NLabelKey: string;
    value: string;
};

export type ListingsSortOrderState = {
    currentSortOrder: string;
    options: SortOrderOption[];
};

export type RawSortOrderData = {
    options: RawSortOrderOption[];
    currentSortOrder: string;
};

export interface InitialiseSortOrderAction {
    type: typeof INITIALISE;
    t: TranslatorTFunction;
    sortOrderData: RawSortOrderData;
}

export interface UpdateCurrentSortOrderAction {
    type: typeof UPDATE_CURRENT_SORT_ORDER;
    currentSortOrder: string;
}
export interface ResetCurrentSortOrderAction {
    type: typeof RESET_SORT_ORDER;
}

interface HydrateFiltersAction {
    type: typeof HYDRATE;
    payload: RootState;
}

export type ListingsSortActionTypes =
    | InitialiseSortOrderAction
    | UpdateCurrentSortOrderAction
    | ResetCurrentSortOrderAction
    | HydrateFiltersAction;
